<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import Drawer from 'primevue/drawer';

defineProps<{
  html: string;
}>();

const visible = defineModel<boolean>('visible', { default: false });

const DESKTOP_BREAKPOINT = 641;
const position = ref<'bottom' | 'right'>(
  typeof window !== 'undefined' && window.innerWidth >= DESKTOP_BREAKPOINT ? 'right' : 'bottom'
);

function onResize(): void {
  position.value = window.innerWidth >= DESKTOP_BREAKPOINT ? 'right' : 'bottom';
}

onMounted(() => window.addEventListener('resize', onResize));
onUnmounted(() => window.removeEventListener('resize', onResize));
</script>

<template>
  <Drawer
    v-model:visible="visible"
    :position="position"
    :modal="true"
    :show-close-icon="true"
    header="Terms & conditions"
    class="terms-sheet"
    data-testid="terms-sheet"
  >
    <div
      class="terms-sheet__body"
      data-testid="terms-sheet__body"
      v-html="html"
    />
  </Drawer>
</template>

<style scoped>
:global(.p-drawer-right .p-drawer.terms-sheet) {
  width: 420px;
  max-width: 94vw;
}
:global(.p-drawer-bottom .p-drawer.terms-sheet) {
  height: auto;
  max-height: 85vh;
  border-top-left-radius: var(--app-radius-xl);
  border-top-right-radius: var(--app-radius-xl);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
:global(.terms-sheet .p-drawer-content) {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
.terms-sheet__body {
  padding: var(--app-space-16);
  font-size: var(--app-font-size-body-base);
  line-height: var(--app-line-height-body-base);
  color: var(--app-text-primary);
}
.terms-sheet__body :deep(p) {
  margin: 0 0 var(--app-space-12);
}
.terms-sheet__body :deep(ul),
.terms-sheet__body :deep(ol) {
  margin: 0 0 var(--app-space-12);
  padding-left: var(--app-space-20);
}
</style>
